import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import ViewOrdonnance from '@/views/vente/view-ordonnance';

export default {
    name: 'vente',
    components: {
        DateFilter, ViewOrdonnance
    },
    props: [],
    data () {
        return {
            fields: [ 'patient', 'produits','date', 'actions'],
            filter: "",
            perPage: 20,
            currentPage: 1,
            // filter_date: null,
            loading: 0,
            is_loading: true,
            is_empty: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            filter_date: "",
            curr_month: "",
            current_date_filter: {},
            is_month: false,
            liste_ordonnances: [],
            liste_protocoles: [],
            vente_id: 0,
            ord_is_loading: false
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.getListeVente(data)
            this.is_month = true
        }
    },

    computed: {
        ventes() {
            return this.$store.getters['ventes']
        },

        liste_ordonnances_patient() {
            return this.$store.getters['liste_ordonnances_patient']
        },
    },

    mounted () {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: ""
        }
        this.current_date_filter = data
        this.getListeVente(data)
    },

    methods: {
        getListeVente(data) {
            this.is_loading = true
            this.$store.dispatch("getVentes", data).then(() => {
                if (this.ventes.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeVente(data)
            this.is_month = false
        },

        livraison(id) {
            this.loading = id
            const data = {
                "utilisateur": this.$store.getters['authInfo'].user.name
            }

            this.$store.dispatch('livraisonVente', { id: id, utilisateur: data }).then(() => {
                this.refreshVente()
                this.loading = false
            })
        },

        /**
         * Rafraichir la liste des article en attente de vente
         */
        refreshVente() {
            this.getListeVente(this.current_date_filter)
        }, 

        viewDetail(liste_articles, vente_id) {
            this.ord_is_loading = true
            this.liste_ordonnances = []
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_ordonnances = liste_articles.groupBy('ordonnance_id')
            const tmp_grouped_protocoles = liste_articles.groupBy('protocole_id')

            // let is_ordonnance = 0
            for (const key_ordonnance in tmp_grouped_ordonnances) {
                if (key_ordonnance > 0) {
                    let tmp_ord = {
                        ordonnance_id: key_ordonnance
                    }
                    this.liste_ordonnances.push(tmp_ord)
                }
            }

            for (const key_protocole in tmp_grouped_protocoles) {
                if (key_protocole > 0) {
                    let tmp_prot = {
                        protocole_id: key_protocole
                    }
                    this.liste_protocoles.push(tmp_prot)
                }
            }

            this.vente_id = vente_id
            this.$store.dispatch('getListeOrdonnancePatientByListeOrdonnance', this.liste_ordonnances).then(() => {
                
                $('.vw-ord-'+vente_id).modal('show')
                this.ord_is_loading = false
            })
        }
    }
}